<template>
  <div class="ask-anything-fullpage">
    <div class="ask-anything-body">
      <AskMain />
      <AskSide />
    </div>

    <AskAgreementModal />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import AskMain from './AskMain.vue';
import AskSide from './AskSide.vue';
import AskAgreementModal from './AskAgreementModal.vue';
import { useChatStore } from '@frontend/ui/stores/chatStore';

const chatStore = useChatStore();

onMounted(async () => {
  await chatStore.createSocket('/ws/agent-chat/');
  console.log('THIS IS THE SOCKET', chatStore.socket);
});
</script>

<style scoped>
.ask-anything-fullpage {
  background-color: #fff;
  container-type: inline-size;
  container-name: ask-anything-container;
}

.ask-anything-body {
  display: grid;
  grid-template-columns: 1fr var(--stk-sidenav-width);
}

@container ask-anything-container (width < 1000px) {
  .ask-anything-body {
    grid-template-columns: 1fr;
  }
}
</style>
